
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'SRadio',
  components: {},
  props: {},

  setup() {
    const classes = computed(() => {
      const result = 's-radio ';
      return result;
    });

    return { classes };
  },
});
